import type { BillingTranslation } from './en';

/** Hindi. Pending review by native speakers, as the note in the interface says. */
export const billingHi: BillingTranslation = {
  nav: 'प्लान और बिलिंग',
  title: 'प्लान और बिलिंग',
  description: 'आपका प्लान, इस महीने का इस्तेमाल, आपके इनवॉइस, और आपके ईमेल पर दिखने वाला नाम।',
  loading: 'आपका प्लान लोड हो रहा है',
  checkout: {
    done: 'धन्यवाद। आपके भुगतान की पुष्टि हो रही है, और कुछ ही पल में आपका प्लान बदल जाएगा।',
    cancelled: 'आपने भुगतान पेज छोड़ दिया। कोई शुल्क नहीं लिया गया।',
  },
  plan: {
    title: 'आपका प्लान',
    none: 'कोई प्लान नहीं: कुछ भी सीमित नहीं',
    price: '{{price}} प्रति माह',
    provider: {
      free: 'मुफ़्त। ज़्यादा ज़रूरत होने पर आप अपग्रेड कर सकते हैं।',
      stripe: 'Stripe के ज़रिए कार्ड से भुगतान।',
      whmcs: 'बिल आपका प्रदाता भेजता है। भुगतान या प्लान बदलने के लिए क्लाइंट एरिया खोलें।',
      manual: 'इस सर्वर से इनवॉइस के ज़रिए बिल।',
    },
    grace:
      'एक भुगतान नहीं हो पाया। आपका प्लान {{date}} तक बना रहेगा। उसे बनाए रखने के लिए उससे पहले इनवॉइस चुकाएँ; वरना वर्कस्पेस मुफ़्त प्लान पर चला जाएगा।',
    trial: '{{date}} तक ट्रायल। उसके बाद, अगर आप कोई प्लान नहीं चुनते, तो वर्कस्पेस मुफ़्त प्लान पर चला जाएगा।',
    renews: '{{date}} को रिन्यू होगा।',
    ends: '{{date}} को ख़त्म होगा। यह रिन्यू नहीं होगा।',
  },
  status: {
    none: 'कोई सब्सक्रिप्शन नहीं',
    trialing: 'ट्रायल',
    active: 'सक्रिय',
    past_due: 'भुगतान बाकी',
    unpaid: 'भुगतान नहीं हुआ',
    canceled: 'रद्द',
    incomplete: 'भुगतान का इंतज़ार',
    paused: 'रुका हुआ',
  },
  providers: {
    free: 'मुफ़्त',
    stripe: 'Stripe',
    whmcs: 'WHMCS',
    manual: 'इस सर्वर के इनवॉइस',
  },
  actions: {
    manage: 'बिलिंग प्रबंधित करें',
    clientArea: 'क्लाइंट एरिया खोलें',
    upgrade: 'अपग्रेड करें',
    chooseLabel: '{{plan}} पर अपग्रेड करें',
  },
  plans: {
    title: 'प्लान',
    description:
      'कोई प्लान चुनें और सुरक्षित भुगतान पेज पर उसका भुगतान करें। आप बाद में उसे बदल या रद्द कर सकते हैं।',
    limit: '{{limit}}: {{value}}',
    unlimited: 'कोई सीमा नहीं',
    trialDays: 'ट्रायल: {{n}} दिन मुफ़्त',
    readOnly: 'प्लान केवल बिलिंग संभालने वाले लोग बदल सकते हैं।',
  },
  usage: {
    title: 'इस महीने का इस्तेमाल',
    details: 'विवरण और AI बजट',
  },
  invoices: {
    title: 'इनवॉइस',
    loading: 'इनवॉइस लोड हो रहे हैं',
    number: 'इनवॉइस',
    date: 'तारीख़',
    total: 'कुल',
    status: 'स्थिति',
    links: 'लिंक',
    pay: 'भुगतान करें',
    view: 'देखें',
    pdf: 'PDF',
    empty: 'अभी कोई इनवॉइस नहीं।',
    allInReports: 'सभी इनवॉइस',
    inClientArea: 'आपके इनवॉइस आपके प्रदाता के क्लाइंट एरिया में हैं।',
    statuses: {
      draft: 'ड्राफ़्ट',
      open: 'खुला',
      paid: 'चुकाया गया',
      void: 'रद्द',
      uncollectible: 'वसूल नहीं हुआ',
    },
  },
  sender: {
    title: 'ईमेल भेजने वाले का नाम',
    description: 'इस वर्कस्पेस के ईमेल पर लोगों को दिखने वाला नाम, जैसे आमंत्रण, रसीदें और भुगतान सूचनाएँ।',
    loading: 'भेजने वाले का नाम लोड हो रहा है',
    label: 'भेजने वाले का नाम',
    hint: 'वर्कस्पेस का नाम ({{name}}) इस्तेमाल करने के लिए खाली छोड़ें।',
    save: 'नाम सहेजें',
    saved: 'भेजने वाले का नाम सहेजा गया।',
  },
  suspended: {
    title: 'यह वर्कस्पेस निलंबित है',
    description:
      'आप देख सकते हैं, लेकिन कुछ भी बदला नहीं जा सकता, और आपकी वेबसाइट की चैट ऑफ़लाइन दिखती है। इसे फिर से चालू कराने के लिए अपने प्रदाता से संपर्क करें।',
  },
  provisioning: {
    queued: 'इस ब्रांड के लिए चैट सेट हो रही है। इसमें लगभग एक मिनट लगता है।',
    running: 'चैट सेट हो रही है: {{step}}',
    failed:
      'चैट सेटअप रुक गया। {{error}} फिर से कोशिश करने के लिए «Chatwoot जोड़ें» चुनें: यह वहीं से आगे बढ़ता है जहाँ रुका था।',
    steps: {
      account: 'खाता बन रहा है',
      integration_user: 'Hamnivo का यूज़र जोड़ा जा रहा है',
      account_user: 'Hamnivo को पहुँच दी जा रही है',
      inbox: 'इनबॉक्स बन रहा है',
      bot: 'AI सहायक जोड़ा जा रहा है',
      bot_attached: 'AI सहायक को इनबॉक्स से जोड़ा जा रहा है',
      webhook: 'अपडेट चालू हो रहे हैं',
      dashboard_app: 'कोपायलट जोड़ा जा रहा है',
      done: 'पूरा हो रहा है',
    },
  },
  signup: {
    closed:
      'इस सर्वर पर साइन-अप केवल आमंत्रण से होता है। अगर आपको आमंत्रण मिला है, तो वही पता इस्तेमाल करें जिस पर आमंत्रण भेजा गया था।',
    closedError:
      'यह सर्वर केवल आमंत्रित पतों के लिए खाते बनाता है। वही पता इस्तेमाल करें जिस पर आपका आमंत्रण आया था, या आमंत्रण माँगें।',
    captcha: 'पुष्टि करें कि आप इंसान हैं',
    captchaMissing: 'ऊपर की जाँच पूरी करें, फिर दोबारा कोशिश करें।',
    captchaFailed: 'जाँच पास नहीं हुई। फिर से कोशिश करें।',
    captchaUnavailable:
      'जाँच लोड नहीं हो सकी। अपना कनेक्शन जाँचें या कंटेंट ब्लॉकर बंद करें, फिर पेज दोबारा लोड करें।',
  },
  tenants: {
    suspended: 'निलंबित: केवल पढ़ने के लिए',
    createClosed:
      'इस सर्वर पर वर्कस्पेस बनाना बंद है। आपका प्रदाता उन्हें बनाता है, या आपको किसी वर्कस्पेस में आमंत्रित करता है।',
  },
  platform: {
    nav: 'साइन-अप और बिलिंग',
    signup: {
      title: 'सार्वजनिक साइन-अप',
      description: 'क्या इस सर्वर पर कोई भी खाता और वर्कस्पेस बना सकता है। आमंत्रित लोग हमेशा जुड़ सकते हैं।',
      loading: 'साइन-अप सेटिंग लोड हो रही है',
      open: 'सबके लिए खुला',
      closed: 'केवल आमंत्रण से',
      overridden: '{{time}} को यहाँ बदला गया',
      envDefault: 'सर्वर सेटिंग (HAMNIVO_PUBLIC_SIGNUP): {{state}}',
      openShort: 'खुला',
      closedShort: 'बंद',
      turnstileOn: 'Cloudflare Turnstile हर साइन-अप की जाँच करता है।',
      turnstileOff:
        'Cloudflare Turnstile बंद है। इसे चालू करने के लिए TURNSTILE_SITE_KEY और TURNSTILE_SECRET_KEY सेट करें।',
      defaultPlan: 'नए वर्कस्पेस इस प्लान से शुरू होते हैं: {{plan}}',
      unlimited: 'कोई प्लान नहीं (कुछ भी सीमित नहीं)',
      close: 'साइन-अप बंद करें',
      openIt: 'साइन-अप खोलें',
      follow: 'सर्वर सेटिंग इस्तेमाल करें',
      needsAdmin: 'इसे केवल प्लेटफ़ॉर्म एडमिन बदल सकते हैं।',
      saved: 'साइन-अप सेटिंग सहेजी गई।',
    },
    plans: {
      title: 'प्लान',
      description: 'बिलिंग कमांड plan:set से प्लान जोड़ें या बदलें (Hamnivo को सेवा के रूप में चलाने की गाइड देखें)।',
      loading: 'प्लान लोड हो रहे हैं',
      name: 'नाम',
      key: 'कुंजी',
      price: 'मासिक कीमत',
      trial: 'ट्रायल',
      stripe: 'Stripe कीमत',
      trialDays: '{{n}} दिन',
    },
    keys: {
      title: 'ऑपरेटर API कुंजियाँ',
      description:
        'WHMCS जैसे बिलिंग सिस्टम वर्कस्पेस बनाने, निलंबित करने और बदलने के लिए कुंजी इस्तेमाल करते हैं। कुंजी केवल एक बार, बनाते समय दिखती है।',
      loading: 'कुंजियाँ लोड हो रही हैं',
      name: 'नाम',
      nameHint: 'कुंजी कहाँ इस्तेमाल होगी, जैसे WHMCS।',
      nameRequired: 'कुंजी को एक नाम दें।',
      create: 'कुंजी बनाएँ',
      created: 'यह कुंजी अभी कॉपी करें और बिलिंग सिस्टम में रखें। यह दोबारा नहीं दिखेगी।',
      copy: 'कुंजी कॉपी करें',
      copied: 'कुंजी कॉपी हो गई।',
      copyFailed: 'कॉपी नहीं हो सकी। कुंजी चुनकर ख़ुद कॉपी करें।',
      empty: 'अभी कोई कुंजी नहीं।',
      prefix: 'शुरुआत',
      createdAt: 'बनाई गई',
      lastUsed: 'आख़िरी इस्तेमाल',
      status: 'स्थिति',
      never: 'कभी नहीं',
      active: 'सक्रिय',
      revoked: 'रद्द की गई',
      revoke: 'रद्द करें',
      revokeLabel: 'कुंजी {{name}} रद्द करें',
      revokeTitle: 'कुंजी {{name}} रद्द करें?',
      revokeBody: 'इस कुंजी का इस्तेमाल करने वाले सिस्टम तुरंत काम करना बंद कर देंगे। इसे वापस नहीं किया जा सकता।',
      revokedDone: 'कुंजी रद्द की गई।',
    },
    tenant: {
      title: 'प्लान और स्थिति',
      loading: 'प्लान लोड हो रहा है',
      plan: 'प्लान',
      noPlan: 'कोई प्लान नहीं (कुछ भी सीमित नहीं)',
      trial: '{{date}} तक ट्रायल',
      provider: 'बिल देने वाला',
      graceLabel: 'भुगतान',
      grace: 'विफल; {{date}} तक की मोहलत',
      usage: 'इस अवधि का इस्तेमाल',
      assign: 'प्लान बदलें',
      assignTitle: '{{name}} का प्लान बदलें',
      planField: 'प्लान',
      pickPlan: 'प्लान चुनें',
      startTrial: 'प्लान का ट्रायल ({{n}} दिन) शुरू करें, फिर मुफ़्त प्लान पर लौटें',
      stripeNote:
        'यह वर्कस्पेस Stripe से भुगतान करता है। इसका प्लान Stripe में बदलें, या पहले सब्सक्रिप्शन रद्द करें।',
      assigned: 'प्लान बदला गया।',
      suspend: 'निलंबित करें',
      reactivate: 'फिर से चालू करें',
      suspendTitle: '{{name}} को निलंबित करें?',
      reactivateTitle: '{{name}} को फिर से चालू करें?',
      suspendBody:
        'इसके लोग साइन इन करके देख सकते हैं, लेकिन कुछ भी बदला नहीं जा सकता, और इसकी वेबसाइटों की चैट ऑफ़लाइन दिखती है।',
      reactivateBody: 'सब कुछ फिर से काम करेगा, इसकी वेबसाइटों की चैट भी।',
      reason: 'कारण',
      reasonHint: 'वर्कस्पेस के ऑडिट लॉग और प्लेटफ़ॉर्म ऑडिट लॉग में दर्ज होता है।',
      reasonShort: 'कम से कम 3 अक्षरों का कारण लिखें।',
      suspendedDone: 'वर्कस्पेस निलंबित किया गया।',
      reactivatedDone: 'वर्कस्पेस फिर से चालू किया गया।',
    },
  },
};
